import { type ComponentType } from 'react';

export type { EventHint } from '@sentry/types';

export type { EventListenerCallback, UseEventDispatchHook } from '../events/core';
export type { CaptureExceptionPayload } from '../events/sentry-browser/bridge';

export type {
	Attributes,
	OperationalEventPayload,
	ScreenEventPayload,
	TrackEventPayload,
	UIEventPayload,
} from '../events/analytics-web-client-types';

// eslint-disable-next-line import/order
import {
	Breadcrumb,
	type BreadcrumbAttributes,
	breadcrumbMountedEventChannel,
	internalGasV3OperationalEventChannel,
	internalGasV3ScreenEventChannel,
	internalGasV3TrackEventChannel,
	internalGasV3UIEventChannel,
	internalSentryExceptionChannel,
} from '../channels';

export { Breadcrumb };
export type { BreadcrumbAttributes };

import { createAtlaskitToEventChannelRepackager } from '../events/atlaskit';
import { withBreadcrumb as baseWithBreadcrumb } from '../events/breadcrumbs';

export const { useBreadcrumbedEventDispatch: useGasV3UIEventDispatch } =
	internalGasV3UIEventChannel;
export const { useEventDispatch: useGasV3ScreenEventDispatch } = internalGasV3ScreenEventChannel;
export const { useBreadcrumbedEventDispatch: useGasV3TrackEventDispatch } =
	internalGasV3TrackEventChannel;
export const { useBreadcrumbedEventDispatch: useGasV3OperationalEventDispatch } =
	internalGasV3OperationalEventChannel;

export const { useBreadcrumbedEventDispatch: useSentryExceptionDispatch } =
	internalSentryExceptionChannel;

export const RepackageAtlaskitEvent =
	createAtlaskitToEventChannelRepackager(useGasV3UIEventDispatch);

/**
 * TODO: Old APIs need this to be exposed. Remove whatever's using this and then remove this.
 */
export const { Listener: BreadcrumbMountedListener } = breadcrumbMountedEventChannel;

export const withBreadcrumb = <ComponentPropsType extends {}>(
	Component: ComponentType<ComponentPropsType>,
	name: string,
	attributes?: BreadcrumbAttributes,
) => baseWithBreadcrumb(Component, Breadcrumb, name, attributes);
